import { connect } from 'react-redux'
import { connectWaiter, getWaiter } from 'redux-waiter'
import { compose } from 'recompose'
import { clearModal } from '@hixme/modal'
import { BENEFIT_TYPE_ACCIDENT } from '@hixme/benefit-types'
import { getClientBenefits } from 'modules/api/client-benefits-get'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import cart from 'store/modules/cart'
import person from 'store/modules/persons'
import userSession from 'store/modules/user-session'

// module
import { constants } from '../modules/accident-coverage'
import { datadog } from 'helpers/datadog'

const mapStateToProps = (state) => {
  const waiter = getWaiter(state, constants.GET_ACCIDENT)
  return {
    benefitProducts: (waiter.response && waiter.response.ClientBenefits) || [],
    enrollmentKey: userSession.selectors.getEnrollmentPublicKey(state),
    coveredPersons: [
      person.selectors.getPersonSelector(state),
      ...person.selectors.getDependentsEligibleForBenefits(state),
    ],
    isProcessing: getWaiter(state, cart.constants.CART_ACCIDENT_POST).isPending || false,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onDeclineClick: (coveredPersons, benefitProducts) => {
    dispatch(cart.actions.declineAccidentProduct(coveredPersons, benefitProducts)).then(
      () => {
        datadog.declineBenefits(BENEFIT_TYPE_ACCIDENT, coveredPersons, benefitProducts)
        dispatch(userSession.actions.pushNextBenefitRoute())
      },
      () => {
        dispatch(clearModal())
        dispatch(
          createErrorNotification('There was an error declining accident. Please try again.')
        )
      }
    )
  },
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  connectWaiter({
    name: constants.GET_ACCIDENT,
    requestCreator: ({ EnrollmentPublicKey, PersonPublicKeys }) =>
      getClientBenefits({
          EnrollmentPublicKey,
          BenefitType: BENEFIT_TYPE_ACCIDENT,
          PersonPublicKeys,
        }),
    requestOnMountParams: ({ enrollmentKey, coveredPersons }) => {
      const keys = coveredPersons.map((i) => i.Id)
      return {
        EnrollmentPublicKey: enrollmentKey,
        PersonPublicKeys: keys,
      }
    },
  })
)(DeclineCoverageModal)
